import { useLanguage } from '../hooks/useLanguage';
import formatPriceUtil, { defaultPriceFormatConfig, PriceFormatConfig } from '../utils/price-format';

export type FormatPriceFn = (price: string | number, options?: Omit<PriceFormatConfig, 'language'>) => string;

export const usePriceFormatter = (): FormatPriceFn => {
  const { language } = useLanguage();

  const formatPrice = (price: string | number, options?: Omit<PriceFormatConfig, 'language'>) =>
    formatPriceUtil(price, {
      ...(defaultPriceFormatConfig as PriceFormatConfig),
      ...options,
      language,
    });

  return formatPrice;
};
